import Button from '@components/Button';
import CtaLayout from '@components/CtaLayout';
import Header from '@components/Header';
import Image from '@components/Image';
import Row from '@components/Row';
import styled from '@emotion/styled';
import useAppCustom from '@hooks/useAppCustom';
import { AppScreen } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType } from '@stackflow/react';
import { useEffect } from 'react';
import { useCookies } from 'react-cookie';

const LinkActivity: ActivityComponentType = () => {
  const { main } = useAppCustom();
  const isIos = !(navigator.userAgent.match(/iPhone|iPad|iPod/i) === null);
  const projectId = '0ncm4z34jppdf';
  const [_, setCookies] = useCookies(['projectId']);
  useEffect(() => {
    setCookies('projectId', projectId, {
      path: '/',
      maxAge: 60 * 60 * 24 * 365 * 20,
    });
  }, []);

  const openStore = () => {
    const iosUrl = 'https://apps.apple.com/us/app/%ED%94%BC%EC%97%90%EC%8A%A4%ED%83%807/id6754587894';
    const androidUrl = 'https://play.google.com/store/apps/details?id=co.kr.waldlust.fiesta7';
    if (isIos) {
      window.location.href = iosUrl;
    } else {
      window.location.href = androidUrl;
    }
  };

  const openApp = () => {
    window.location.href = 'fiesta7://';
  };
  return (
        <AppScreen>
            <CtaLayout
                footer={<Row fullWidth spacing={8}>
                <Button variant='secondary' fullWidth onClick={openApp}>앱 실행</Button>
                <Button fullWidth onClick={openStore}>앱 설치</Button>
            </Row>}>
                <Container>
                    <LogoWrapper>
                        <Image src={main.logo}/>
                    </LogoWrapper>
                </Container>
            </CtaLayout>
        </AppScreen>
  );
};

const Container = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
`;

const LogoWrapper = styled.div`
    flex: 1;
    padding-top: 80px;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    img {
        max-width: calc(100% - 40px);
    };
`;

export default LinkActivity;
